import { render } from "./About.vue?vue&type=template&id=b207e238&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=b207e238&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3192284683/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b207e238"]])

export default __exports__